import { useEffect } from "react";
import { DashboardViewModel } from "../../viewmodels/dashboard/DashboardViewModel";

export default function Dashboard(props) {
  const { logout } = props;

  const {
    getSeasonStatus,
    switchSeasonStatus,
    seasonStatus,
    seasonLoading,
    switchSeasonLoading,
  } = DashboardViewModel(logout);

  useEffect(() => {
    getSeasonStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const seasonText =
    seasonStatus === 0 ? "Cooling" : seasonStatus === 1 ? "Heating" : "Unknown";
  const nextSeasonText = seasonStatus === 0 ? "Heating" : "Cooling";

  return (
    <div className="p-6">
      <div className="max-w-md rounded-lg border border-gray-200 bg-white p-5 shadow-sm">
        <p className="mt-2 text-lg font-semibold text-gray-900">
          Current season setting: {seasonLoading ? "Loading..." : seasonText}
        </p>
        <p className="mt-1 text-sm text-gray-500">
          Toggle between cooling and heating mode.
        </p>

        <div className="mt-4">
          <button
            onClick={switchSeasonStatus}
            disabled={
              seasonLoading || switchSeasonLoading || seasonStatus === null
            }
            className="inline-flex items-center justify-center rounded-md bg-main-purple px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-400"
          >
            {switchSeasonLoading
              ? "Switching..."
              : `Switch to ${nextSeasonText}`}
          </button>
        </div>
      </div>
    </div>
  );
}
